import axios from "axios";
import { auth } from "../firebase"; // Make sure this points to your firebase setup

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "/api",
});

// Attach Firebase ID token to every request (if user is signed in)
api.interceptors.request.use(async (config) => {
  const user = auth.currentUser;
  if (user) {
    const token = await user.getIdToken();
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
